import { render, staticRenderFns } from "./dialog-add-classification.vue?vue&type=template&id=0ac8ec68&scoped=true&"
import script from "./dialog-add-classification.vue?vue&type=script&lang=js&"
export * from "./dialog-add-classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8ec68",
  null
  
)

export default component.exports